"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgCurrencyEditor_1 = require("./component/CfgCurrencyEditor");
var CfgCurrencyList_1 = require("./component/CfgCurrencyList");
var CfgCurrencyListBase_1 = require("./lang/CfgCurrencyListBase");
var PCfgCurrencyList = /** @class */ (function (_super) {
    __extends(PCfgCurrencyList, _super);
    function PCfgCurrencyList(props) {
        return _super.call(this, props) || this;
    }
    PCfgCurrencyList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            lang: CfgCurrencyListBase_1.CfgCurrencyListLangFactory.getLangInstance(this.props.state.getLang()),
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PCfgCurrencyList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgCurrencyList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgCurrencyList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgCurrencyList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgCurrencyList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgCurrencyList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgCurrencyEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), lang: this.state.lang }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgCurrencyEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), lang: this.state.lang }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgCurrencyList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, lang: this.state.lang }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgCurrencyList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgCurrencyList.getPageDescription = function (state) {
        var lang = CfgCurrencyListBase_1.CfgCurrencyListLangFactory.getLangInstance("RU"); //state.getLang()
        return {
            icon: "hand-holding-usd",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_currency_config + "-id",
            itemTitle: lang.document_title,
            route: routes_1.routes.page_config_currency_config,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgCurrencyList;
}(React.Component));
exports.default = PCfgCurrencyList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/PCfgCurrencyList.tsx
// module id = 2038
// module chunks = 0